// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__dS8Dz","header":"Layout_header__FZ6k4","closeIcon":"Layout_closeIcon__kvES4","content":"Layout_content__Btcef"};